import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import WebsiteBanner_Desktop from "../assets/Website_desktop_popup.png";
import WebsiteBanner_Mobile from "../assets/Website_mobile_popup.png";
import { useContext } from "react";
import { CurrencyContext } from "./CurrencyContext";

const dlink={
  USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&cruiseline=8&ship=13717&departureports=SIN&sortcolumn=price&sortorder=asc&_gl=1*18l73b2*_ga*MTIwMjg2MjA5My4xNzU1NDkyNDk1*_ga_PBH0ZZNRGB*czE3NTU3MTIyNDckbzEyJGcxJHQxNzU1NzEyMzMyJGo1MSRsMCRoODM3NjI1OTkw&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_term=undefined&matchtype=undefined&device=undefined&utm_content=undefined&utm_adgroup=undefined",

  INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&destinationtype=All&cruiseline=8&ship=13717&departureports=SIN&sortcolumn=price&sortorder=asc&_gl=1*1r1iz3r*_ga*MjgwNjA1NTkzLjE3NTQ2MzUwNjE.*_ga_PBH0ZZNRGB*czE3NTU2MDMzODgkbzIzJGcxJHQxNzU1NjAzMzkyJGo1NiRsMCRoMTg5MzMwMTc5OQ..&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_term=undefined&matchtype=undefined&device=undefined&utm_content=undefined&utm_adgroup=undefined"
}

function AutoShowModal() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const Currency = useContext(CurrencyContext);

  // Watch for resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Bootstrap modal logic
  useEffect(() => {
    let bootstrapModal;
    let timer;

    // Check if banner was already shown
    const bannerShown = sessionStorage.getItem("SixOffBanner");

    if (bannerShown !== "true") {
      // Show modal after 2 seconds
      timer = setTimeout(() => {
        const modalEl = document.getElementById("autoModal");

        if (modalEl) {
          // Dynamically import Bootstrap Modal
          import("bootstrap").then(({ Modal }) => {
            bootstrapModal = new Modal(modalEl, {
              keyboard: false,
              backdrop: "static",
            });
            bootstrapModal.show();
            sessionStorage.setItem("SixOffBanner", "true"); // Mark as shown
          });
        }
      }, 2000);

      // Clean up timer on unmount
      return () => {
        if (timer) clearTimeout(timer);
      };
    }
  }, []);

  return (
    <div
      className="modal fade"
      id="autoModal"
      tabIndex="-1"
      aria-labelledby="autoModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen cmodal-dialog">
        <div className="modal-content cmodal-content">
          {/* Close button */}
          <button
            type="button"
            className="custom-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            ×
          </button>

          {/* Modal body with responsive banner controlled by React */}
          <div className="modal-body cmodal-body p-0">
            <a
              href={dlink[Currency.currencyCode]}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={isMobile ? WebsiteBanner_Mobile : WebsiteBanner_Desktop}
                alt="Promo Banner"
                style={{ display: "block", width: "100%", height: "auto" }}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AutoShowModal;
